export default __webpack_public_path__ + "static/media/logo_arkid_white.351ae5ce.svg";